import * as React from 'react';
import LoadingSpinner from '../reuseables/LoadingSpinner';

const Loading = () => (
    <div className="loading-container">
        <LoadingSpinner visible={true} />
    </div>
);

export default Loading;